import {
  ticksFormat
} from '../common/datetime';


export class UsercardService {
  constructor($http, PermissionService) {
    this.$http = $http;
    this.permission = PermissionService;
  }

  loadList(callback) {
    if (!this.permission.usercardsEnabled) return Promise.resolve('permission denited');
    return this.$http.get('/usercard/item_list/')
      .then(({
        data,
        status
      }) => {
        this.items = data;
        this.filter_values = Array.from(new Set(data.map(d => d.ad_attributes && d.ad_attributes.office)));
        if (callback) callback(data);
      });
  }

  loadItem(full_name, callback) {
    return this.$http.get('/usercard/item/' + full_name)
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }

  loadWebcamShots(full_name, callback) {
    return this.$http.get('/usercard/webcam_shots/' + full_name)
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }

  saveItem(full_name, value, callback) {
    return this.$http.post('/usercard/item/' + full_name, value)
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }

  selectItem(full_name) {
    console.log('selectItem ' + full_name);
    this.selectedAttr = undefined;
    this.loadItem(full_name, data => {
      this.selectedItem = data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/usercard/usercard.service.js